
































































import { Component, Vue } from "vue-property-decorator";
import SuperSpacesComponent from "@/app/views/nubii/components/sidebar/superSpacesList/superSpaces.component.vue";

@Component({
  name: "city-component",

  components: { SuperSpacesComponent },
})
export default class CityComponent extends Vue {
  search = "";
  searchTimeOut = null;
  mounted() {
    document.addEventListener("mousemove", this.parallax);
  }
  destroyed() {
    document.removeEventListener("mousemove", this.parallax);
  }

  // Magic happens here
  parallax(e) {
    const elem = document.getElementById("parallax");
    let _w = window.innerWidth / 2;
    let _h = window.innerHeight / 2;
    let _mouseX = e.clientX;
    let _mouseY = e.clientY;
    let _depth1 = `${50 - (_mouseX - _w) / -90}% ${50 - (_mouseY - _h) / -90}%`;
    let _depth2 = `${50 - (_mouseX - _w) / -90}% ${50 - (_mouseY - _h) / -90}%`;
    let _depth3 = `${50 - (_mouseX - _w) / -90}% ${50 - (_mouseY - _h) / -90}%`;
    let x = `${_depth3}, ${_depth2}, ${_depth1}`;
    elem.style.backgroundPosition = x;
  }
  get superSpacesList() {
    const superSpaces = this.$store.getters["SuperSpaceStore/getSuperSpaces"];
    return superSpaces
      .filter((a) =>
        this.search !== ""
          ? a.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(
                this.search
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
              )
          : a
      )
      .filter((a) => a.isFavourite === false && a.isPublic === false);
  }
  get superSpacesFavouriteList() {
    const superSpaces = this.$store.getters["SuperSpaceStore/getSuperSpaces"];
    return superSpaces
      .filter((a) =>
        this.search !== ""
          ? a.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(
                this.search
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
              )
          : a
      )
      .filter((a) => a.isFavourite === true);
  }
  get superSpacesPublicList() {
    const superSpaces = this.$store.getters["SuperSpaceStore/getSuperSpaces"];
    return superSpaces
      .filter((a) =>
        this.search !== ""
          ? a.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(
                this.search
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
              )
          : a
      )
      .filter((a) => a.isPublic === true && a.isFavourite === false);
  }

  getMoreSuperSpaces(): void {
    this.$store.dispatch("SuperSpaceStore/getSuperSpacesAction", {
      pagination: false,
      callback: async (response) => {
        // do nothing
      },
      callbackError: (error) => {
        console.log("City On ", error);
      },
    });
  }
  get disabledLoader(): boolean {
    const lastPage =
      this.$store.getters["SuperSpaceStore/getLastPageSuperSpaces"];
    const page =
      this.$store.getters["SuperSpaceStore/getSuperSpacesAvailablePage"];
    return page > lastPage;
  }

  async onSearch(): Promise<void> {
    const lengthUsers = this.superSpacesList.filter((a) =>
      this.search !== ""
        ? a.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(
              this.search
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            )
        : a
    ).length;
    if (lengthUsers < 5) {
      if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.searchTimeOut = setTimeout(() => {
        this.$store.dispatch("SuperSpaceStore/getSuperSpacesAction", {
          name: this.search,
          pagination: false,
          callback: async (response) => {
            //do nothing
          },
          callbackError: (error) => {
            console.log("City On ", error);
          },
        });
      }, 1000);
    }
  }
}
